import { cx } from '@linaria/atomic';
import { PolymorphicComponentPropWithoutRef } from '@frontend/design-system';
import { SettingsSectionStyles } from './settings-section.styles';

type Props = {
  removeDefaultStyles?: boolean;
};

type SettingsSectionProps<C extends React.ElementType> = PolymorphicComponentPropWithoutRef<C, Props>;

export const SettingsSection = <C extends React.ElementType = 'div'>({
  as,
  children,
  removeDefaultStyles,
  ...rest
}: SettingsSectionProps<C>) => {
  const Component = as || 'div';

  return (
    <Component
      {...rest}
      className={cx(!removeDefaultStyles && SettingsSectionStyles.settingsSectionComponentStyle1, rest.className)}
    >
      {children}
    </Component>
  );
};
